import { ErrorMessage, Field } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, Table } from "react-bootstrap";
import {
  BsChevronDown,
  BsChevronUp,
  BsDashLg,
  BsExclamationCircleFill,
  BsPlusLg,
  BsThreeDotsVertical,
} from "react-icons/bs";
import Select from "react-select";
import TooltipComponent from "../../../components/TooltipComponent";
import {
  getFundRequest4LowPriceOnItemId,
  getFundRequestDetailsOnItemId,
} from "../../../services/contractorApi";
import ReactTextareaAutosize from "react-textarea-autosize";
import { ItemRemarksCell, useItemRemarkMap } from "../../../components/ItemRemarks";
import { formatNumberToINR, formatAmountINR, to3, twoDecimal, onlyDecimalKey, handleDecimalPaste } from "../../../utils/helper";

const calculateItemAmount = (qty, rate) => Number((Number(qty) * Number(rate)).toFixed(2));

const FundTableView = ({
  props,
  main,
  id,
  pushFund,
  removeFund,
  edit,
  type,
  itemMasterData,
  setFinalRequestAmount,
  previousFundAmountData,
}) => {
  const [collapsedRows, setCollapsedRows] = useState([]);
  // each item's Request + Approve remarks, shown and edited in its own row
  const itemRemarks = useItemRemarkMap("fund", edit?.id);
  const [lowPrice, setLowPrice] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({});
  const [newtransfererror, showNewTransferError] = useState({});

  // useEffect(() => {
  //   if (main?.transfer_fund[0]?.item_name) {
  //     main?.transfer_fund?.map((itm, index) => {
  //       handleFundRequestDetails(
  //         itm?.item_name?.value,
  //         id,
  //         props.setFieldValue,
  //         index,
  //         itm?.item_name?.hsncode
  //       );
  //     });
  //   }
  // }, [main]);

  useEffect(() => {
    // ✅ create screen me auto API fire nahi karni
    if (type === "create") return;
    console.log(main);
    console.log(props);

    if (main?.transfer_fund?.[0]?.item_name) {
      main.transfer_fund.forEach((itm, index) => {
        if (itm?.item_name?.value) {
          handleFundRequestDetails(
            itm.item_name.value,
            id,
            props.setFieldValue,
            index,
            itm.item_name.hsncode,
          );
        }
      });
    }

    // eslint-disable-next-line
  }, []);

  const toggleRow = (index) => {
    setCollapsedRows((prev) => {
      const isCollapsed = prev.includes(index);
      if (isCollapsed) {
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const fetch4LowPriceData = async (index, hsncode) => {
    setLoading(true);
    const res = await getFundRequest4LowPriceOnItemId(hsncode);
    if (res.status) {
      setLowPrice((prevData) => {
        return { ...prevData, [index]: res.data };
      });
    } else {
      setLowPrice([]);
    }
    setLoading(false);
  };

  // const totalTransferFund = main?.transfer_fund.reduce(
  //   (total, itm) => total + +itm?.request_transfer_fund || 0,
  //   0
  // );

  const totalTransferFund = main?.transfer_fund?.reduce((total, itm) => {
    // ✅ create mode → live multiply
    if (type === "create") {
      const price = Number(
        itm.current_price || itm.price || itm.new_price || 0,
      );

      const qty = Number(itm.transfer_quantity || 0);

      return total + calculateItemAmount(qty, price);
    }

    // ✅ old flow untouched
    return total + (parseFloat(itm?.request_transfer_fund) || 0);
  }, 0);

  const totalNewTransferFund = main?.new_transfer_fund?.reduce(
    (total, itm) => total + (parseFloat(itm?.request_transfer_fund) || 0),
    0,
  );
  useEffect(() => {
    setFinalRequestAmount(totalNewTransferFund + totalTransferFund);
  }, [totalNewTransferFund, totalTransferFund]);

  // DEFAULT = FULL TRANSFER, PARTIAL ALLOWED: initialize each row's transfer
  // qty/amount to the FULL remaining approved quantity so "transfer everything"
  // stays a one-click default. But this is only an INITIALIZER — it sets the
  // value ONLY when the user hasn't entered a transfer qty yet, so a partial
  // qty the user types is never overwritten. The TRANSFER QTY input's onChange
  // (below) recomputes the amount and the remaining (which flows to reschedule).
  // Runs only for the classic approve/transfer flow (type !== "create").
  useEffect(() => {
    if (type === "create") return;
    if (!main?.transfer_fund?.length) return;

    main.transfer_fund.forEach((itm, index) => {
      const current = itm?.transfer_quantity;
      const alreadyEntered =
        current !== "" && current !== undefined && current !== null;
      if (alreadyEntered) return; // don't clobber the user's partial entry

      const remaining_quantity =
        edit?.transfer_data?.transfer_fund?.[index]?.remaining_quantity ??
        itm?.quantity;
      const priceToUse = Number(
        edit?.approved_data?.request_fund?.[index]?.price || 0,
      );

      const fullQty = parseFloat(Number(remaining_quantity || 0).toFixed(2));
      const fullAmount = calculateItemAmount(fullQty, priceToUse);

      props.setFieldValue(
        `transfer_data[${id}].transfer_fund[${index}].transfer_quantity`,
        fullQty,
      );
      props.setFieldValue(
        `transfer_data[${id}].transfer_fund[${index}].request_transfer_fund`,
        fullAmount,
      );
      // Default is a full transfer → nothing remains to reschedule.
      props.setFieldValue(
        `transfer_data[${id}].transfer_fund[${index}].remaining_quantity`,
        0,
      );
    });
    // eslint-disable-next-line
  }, [main?.transfer_fund?.length, edit]);

  // FULL TRANSFER ONLY (classic flow) — same treatment for the New Transfer Fund
  // rows (new_transfer_fund). The transfer qty/amount inputs are read-only, so
  // here we force the Formik values to the FULL remaining approved qty/amount so
  // the backend receives the full amount. Qty source mirrors the inputs the row
  // already used: edit.transfer_data.new_transfer_fund[i].remaining_quantity (on
  // reschedule/edit) else the approved qty (itm.qty); price source is itm.rate.
  // Runs only for the classic approve/edit flow (type !== "create").
  useEffect(() => {
    if (type === "create") return;
    if (!main?.new_transfer_fund?.length) return;

    main.new_transfer_fund.forEach((itm, index) => {
      const remaining_quantity =
        edit?.transfer_data?.new_transfer_fund?.[index]?.remaining_quantity ??
        itm?.qty;
      const priceToUse = Number(itm?.rate || 0);

      const fullQty = parseFloat(Number(remaining_quantity || 0).toFixed(2));
      const fullAmount = calculateItemAmount(fullQty, priceToUse);

      if (Number(itm?.transfer_quantity) !== fullQty) {
        props.setFieldValue(
          `transfer_data[${id}].new_transfer_fund[${index}].transfer_quantity`,
          fullQty,
        );
      }
      if (Number(itm?.request_transfer_fund) !== fullAmount) {
        props.setFieldValue(
          `transfer_data[${id}].new_transfer_fund[${index}].request_transfer_fund`,
          fullAmount,
        );
      }
      // Full transfer → nothing remains to reschedule.
      if (Number(itm?.remaining_quantity) !== 0) {
        props.setFieldValue(
          `transfer_data[${id}].new_transfer_fund[${index}].remaining_quantity`,
          0,
        );
      }
    });
    // eslint-disable-next-line
  }, [main?.new_transfer_fund?.length, edit]);

  // setFinalRequestAmount(totalNewTransferFund + totalTransferFund);

  const handleFundRequestDetails = async (
    id,
    userById,
    setFieldValue,
    index,
    hsncode,
  ) => {
    const res = await getFundRequestDetailsOnItemId(id);

    // if (res.status) {
    //   setFieldValue(
    //     `request_data[${userById}].transfer_fund[${index}].current_user_stock`,
    //     res.data.request_qty
    //   );
    //   setFieldValue(
    //     `request_data[${userById}].transfer_fund[${index}].previous_price`,
    //     res.data.item_price
    //   );
    // }
    if (res.status) {
      // ⭐ ONLY create mode me direct table fill
      if (type === "create") {
        setFieldValue(
          `transfer_data[${userById}].transfer_fund[${index}].current_user_stock`,
          res.data.request_qty,
        );
      } else {
        // ⭐ old flow untouched
        setFieldValue(
          `request_data[${userById}].transfer_fund[${index}].current_user_stock`,
          res.data.request_qty,
        );

        setFieldValue(
          `request_data[${userById}].transfer_fund[${index}].previous_price`,
          res.data.item_price,
        );
      }
    }
    // else {
    //   setFieldValue(
    //     `request_data[${userById}].transfer_fund[${index}].current_user_stock`,
    //     0
    //   );
    //   setFieldValue(
    //     `request_data[${userById}].transfer_fund[${index}].previous_price`,
    //     0
    //   );
    // }
    else {
      if (type === "create") {
        setFieldValue(
          `transfer_data[${userById}].transfer_fund[${index}].current_user_stock`,
          0,
        );

        setFieldValue(
          `transfer_data[${userById}].transfer_fund[${index}].previous_price`,
          0,
        );
      } else {
        setFieldValue(
          `request_data[${userById}].transfer_fund[${index}].current_user_stock`,
          0,
        );

        setFieldValue(
          `request_data[${userById}].transfer_fund[${index}].previous_price`,
          0,
        );
      }
    }
    fetch4LowPriceData(index, hsncode);
  };

  const formatOptionLabel = ({ label, unique_id, image, imgBase64Format }) => (
    <div className="d-flex">
      {imgBase64Format ? (
        <img
          src={
            image
              ? image
              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
          }
          className="avatar me-2"
        />
      ) : (
        <img
          src={
            image
              ? `${process.env.REACT_APP_API_URL}${image}`
              : `${process.env.REACT_APP_API_URL}/assets/images/default-image.png`
          }
          className="avatar me-2"
        />
      )}
      <span className="small d-grid">
        <span>{label}</span>
        <span className="text-gray">({unique_id})</span>
      </span>
    </div>
  );

  return (
    <>
      <Form.Group as={Col} md={12}>
        <div className="stable-scroll">
          {main?.transfer_fund.length > 0 && (
            <>
              <strong>Transfer Fund</strong>
              <div className="mt-2 table-scroll">
                <Table striped className="text-body bg-new Roles">
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>User Stock</th>
                      <th>Request Price</th>
                      <th>Request Quantity</th>
                      <th>Fund Amount</th>
                      <th>Approve Quantity</th>
                      <th>Approve Price</th>
                      <th>Eligible Transfer Quantity</th>
                      <th>Transfer qty</th>
                      <th>Transfer Amount</th>
                      <th>Remarks</th>

                      <th>
                        <BsThreeDotsVertical />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {main?.transfer_fund.map((itm, index) => (
                      <>
                        <tr key={index}>
                          <td width={160}>
                            <Select
                              className="text-start"
                              menuPortalTarget={document.body}
                              isDisabled={type !== "create"}
                              name={`transfer_data[${id}].transfer_fund[${index}].item_name`}
                              value={itm.item_name}
                              options={itemMasterData?.map((itm) => ({
                                label: itm.name,
                                value: itm.id,
                                unique_id: itm.unique_id,
                                rate: +itm.rate,
                                hsncode: itm.hsncode,
                                description: itm.description,
                                image: itm.image,
                              }))}
                              onChange={(e) => {
                                handleFundRequestDetails(
                                  e.value,
                                  id,
                                  props.setFieldValue,
                                  index,
                                  e.hsncode,
                                );
                                props.setFieldValue(
                                  `transfer_data[${id}].transfer_fund[${index}].current_price`,
                                  e.rate,
                                );
                                props.setFieldValue(
                                  `transfer_data[${id}].transfer_fund[${index}].item_name`,
                                  e,
                                );
                              }}
                              formatOptionLabel={formatOptionLabel}
                            />
                            <ErrorMessage
                              name={`transfer_data[${id}].transfer_fund[${index}].item_name`}
                              component="small"
                              className="text-danger"
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`transfer_data[${id}].transfer_fund[${index}].current_user_stock`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm.current_user_stock}
                              onChange={props.handleChange}
                              disabled={type !== "create"}
                            />
                            <ErrorMessage
                              name={`transfer_data[${id}].transfer_fund[${index}].current_user_stock`}
                              component="div"
                              className="field-error"
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`transfer_data[${id}].transfer_fund[${index}].current_price`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              // value={itm.new_price}
                              value={itm.current_price ?? ""}
                              disabled={type !== "create"}
                              onChange={(e) => {
                                props.setFieldValue(
                                  `transfer_data[${id}].transfer_fund[${index}].fund_amount`,
                                  calculateItemAmount(itm.request_quantity, e.target.value),
                                );

                                props.setFieldValue(
                                  `transfer_data[${id}].transfer_fund[${index}].current_price`,
                                  e.target.value,
                                );
                              }}
                            />
                            <ErrorMessage
                              name={`transfer_data[${id}].transfer_fund[${index}].current_price`}
                              component="div"
                              className="field-error"
                            />
                          </td>
                          <td>
                            <Form.Control
                              name={`transfer_data[${id}].transfer_fund[${index}].request_quantity`}
                              min={1}
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm.request_quantity ?? ""}
                              disabled={type !== "create"}
                              onChange={(e) => {
                                props.setFieldValue(
                                  `transfer_data[${id}].transfer_fund[${index}].fund_amount`,
                                  calculateItemAmount(itm.current_price, e.target.value),
                                );

                                // Keep raw string so trailing dot ("3.") survives mid-type.
                                props.setFieldValue(
                                  `transfer_data[${id}].transfer_fund[${index}].request_quantity`,
                                  e.target.value,
                                );
                              }}
                            />
                            <ErrorMessage
                              name={`transfer_data[${id}].transfer_fund[${index}].request_quantity`}
                              component="small"
                              className="text-danger"
                            />
                          </td>
                          <td>
                            <Form.Control
                              name={`transfer_data[${id}].transfer_fund[${index}].fund_amount`}
                              min={1}
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm.fund_amount ?? ""}
                              disabled={type !== "create"}
                              onChange={props.handleChange}
                            />
                            <ErrorMessage
                              name={`transfer_data[${id}].transfer_fund[${index}].fund_amount`}
                              component="div"
                              className="field-error"
                            />
                          </td>
                          {edit?.approved_data ? (
                            <>
                              {/* <td>
                                <Form.Control
                                  min={1}
                                  disabled={type !== "create"}
                                  type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                  value={
                                    edit?.approved_data?.request_fund?.[index]
                                      ?.quantity
                                  }
                                />
                              </td> */}
                              <td>
                                <Form.Control
                                  min={1}
                                  disabled={type !== "create"}
                                  type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                  name={`transfer_data[${id}].transfer_fund[${index}].quantity`}
                                  value={
                                    type === "create"
                                      ? itm?.quantity
                                      : edit?.approved_data?.request_fund?.[
                                          index
                                        ]?.quantity
                                  }
                                  onChange={
                                    type === "create"
                                      ? props.handleChange
                                      : undefined
                                  }
                                />
                              </td>
                              {/* <td>
                                <Form.Control
                                  min={1}
                                  disabled={type !== "create"}
                                  type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                  value={
                                    edit?.approved_data?.request_fund?.[index]
                                      ?.price
                                  }
                                />
                              </td> */}

                              <td>
                                <Form.Control
                                  min={1}
                                  disabled={type !== "create"}
                                  type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                  name={`transfer_data[${id}].transfer_fund[${index}].price`}
                                  value={
                                    type === "create"
                                      ? itm?.price
                                      : edit?.approved_data?.request_fund?.[
                                          index
                                        ]?.price
                                  }
                                  onChange={
                                    type === "create"
                                      ? props.handleChange
                                      : undefined
                                  }
                                />
                              </td>

                              {/* <td>
                                <Form.Control
                                  min={1}
                                 disabled={type !== "create"}
                                  type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"

                                  value={
                                    edit?.transfer_data
                                      ? edit?.transfer_data?.transfer_fund[
                                        index
                                      ].remaining_quantity
                                      : itm?.quantity
                                  }

                                />
                              </td> */}
                              <td>
                                <Form.Control
                                  min={1}
                                  disabled={type !== "create"}
                                  type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                  name={`transfer_data[${id}].transfer_fund[${index}].remaining_quantity`}
                                  value={
                                    type === "create"
                                      ? itm?.remaining_quantity
                                      : (itm?.remaining_quantity ??
                                        edit?.transfer_data?.transfer_fund?.[
                                          index
                                        ]?.remaining_quantity ??
                                        itm?.quantity)
                                  }
                                  onChange={
                                    type === "create"
                                      ? props.handleChange
                                      : undefined
                                  }
                                />
                              </td>
                            </>
                          ) : null}

                          <td>
                            {/* TRANSFER UP TO APPROVED (no reschedule): the user
                                may transfer the full eligible qty (default) or
                                less. On change we clamp to [0, eligible] and
                                recompute the transfer amount (qty × price).
                                remaining_quantity stays 0 — the partial/
                                reschedule system is removed, so whatever is
                                transferred is treated as the final transfer and
                                the untransferred balance is NOT carried over. */}
                            <Form.Control
                              name={`transfer_data[${id}].transfer_fund[${index}].transfer_quantity`}
                              value={itm?.transfer_quantity ?? ""}
                              type="text"
                              onKeyPress={onlyDecimalKey}
                              onPaste={handleDecimalPaste}
                              inputMode="decimal"
                              onChange={(e) => {
                                const base = `transfer_data[${id}].transfer_fund[${index}]`;
                                const priceToUse = Number(
                                  edit?.approved_data?.request_fund?.[index]
                                    ?.price ??
                                    itm?.price ??
                                    0,
                                );
                                const eligibleQty = parseFloat(
                                  Number(
                                    edit?.transfer_data?.transfer_fund?.[index]
                                      ?.remaining_quantity ??
                                      itm?.quantity ??
                                      0,
                                  ).toFixed(2),
                                );
                                const raw = e.target.value;
                                let qty = raw === "" ? "" : Number(raw);
                                if (qty !== "" && !Number.isNaN(qty)) {
                                  if (qty > eligibleQty) qty = eligibleQty;
                                  if (qty < 0) qty = 0;
                                }
                                props.setFieldValue(
                                  `${base}.transfer_quantity`,
                                  qty,
                                );
                                props.setFieldValue(
                                  `${base}.request_transfer_fund`,
                                  qty === "" || Number.isNaN(qty)
                                    ? ""
                                    : calculateItemAmount(qty, priceToUse),
                                );
                                // No reschedule: whatever is transferred is
                                // final. Keep remaining at 0 so the submit's
                                // reschedule_fund builder never picks this row up.
                                props.setFieldValue(
                                  `${base}.remaining_quantity`,
                                  0,
                                );
                              }}
                            />

                            {error[index] && (
                              <small className="text-danger">
                                Fund Limit Exceeded
                              </small>
                            )}

                            <ErrorMessage
                              name={`transfer_data[${id}].transfer_fund[${index}].transfer_quantity`}
                              component="small"
                              className="text-danger"
                            />
                          </td>

                          <td>
                            {/* FULL TRANSFER ONLY: transfer amount is locked to the
                                full remaining approved amount and is read-only. */}
                            <Form.Control
                              name={`transfer_data[${id}].transfer_fund[${index}].request_transfer_fund`}
                              value={itm?.request_transfer_fund ?? ""}
                              type="text"
                              readOnly
                              disabled
                            />
                          </td>

                          <td>
                            <ItemRemarksCell remarks={itemRemarks} path={`0:request_fund:${index}`} stages={["raised", "approved", "transferred"]} canEdit />
                          </td>

                          <td>
                            <span
                              className={`cursor-pointer text-${
                                collapsedRows.includes(index)
                                  ? "danger"
                                  : "green"
                              }`}
                              onClick={() => toggleRow(index)}
                            >
                              {collapsedRows.includes(index) ? (
                                <BsChevronUp fontSize={"large"} />
                              ) : (
                                <BsChevronDown fontSize={"large"} />
                              )}
                            </span>
                          </td>
                        </tr>
                        {collapsedRows.includes(index) && (
                          <>
                            <tr>
                              <td colSpan={15}>
                                {loading ? (
                                  <p>Loading...</p>
                                ) : (
                                  <Table striped>
                                    <thead>
                                      <th>top 4 low Price</th>
                                      <th>supplier</th>
                                      <th>Location</th>
                                      <th>State</th>
                                      <th>hsn code</th>
                                      <th>ru code</th>
                                      <th>rate</th>
                                    </thead>
                                    <tbody>
                                      {lowPrice[index]?.length > 0 ? null : (
                                        <tr>
                                          <td colSpan={15}>
                                            <BsExclamationCircleFill
                                              fontSize={"large"}
                                              className="mb-2 text-danger"
                                            />
                                            <p className="mb-0">
                                              {" "}
                                              no data available{" "}
                                            </p>
                                          </td>
                                        </tr>
                                      )}
                                      {lowPrice[index]?.map((price, el) => {
                                        return (
                                          <tr key={el}>
                                            <td
                                              className={`fw-bold text-${
                                                el == 0
                                                  ? "green"
                                                  : el == 1
                                                    ? "warning"
                                                    : el == 2
                                                      ? "orange"
                                                      : "danger"
                                              }`}
                                              style={{
                                                fontSize:
                                                  el == 0
                                                    ? 15
                                                    : el == 1
                                                      ? 13
                                                      : el == 2
                                                        ? 12
                                                        : 10,
                                              }}
                                            >
                                              <Field
                                                type="radio"
                                                name={`transfer_data[${id}].transfer_fund[${index}].supplier_id`}
                                                value={price?.supplier_id}
                                                // checked={Boolean(
                                                //   props.values.supplier_id === price?.supplier_id
                                                // )}
                                                onChange={() => {
                                                  props.setFieldValue(
                                                    `transfer_data[${id}].transfer_fund[${index}].supplier_id`,
                                                    price?.supplier_id,
                                                  );
                                                }}
                                                className="form-check-input"
                                              />{" "}
                                              {el + 1}
                                            </td>
                                            <td>
                                              {price?.supplier_name || "-"}
                                            </td>
                                            <td>
                                              {`${
                                                price?.shop_office_number || ""
                                              },
                                            ${price?.street_name || ""},
                                            ${price?.city || ""}`}
                                            </td>
                                            <td>{price?.state || "-"}</td>
                                            <td>{price?.hsncode || "-"}</td>
                                            <td>{price?.rucode || "-"}</td>
                                            <td>{price?.item_rate != null && price?.item_rate !== "" ? formatAmountINR(price.item_rate) : "-"}</td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </Table>
                                )}
                              </td>
                            </tr>
                          </>
                        )}
                      </>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}

          {main?.transfer_fund.length > 0 && (
            <div className="d-flex mt-3 justify-content-end">
              <div className="text-end fw-bold">
                Total Transfer Fund {formatAmountINR(totalTransferFund ?? 0)}
              </div>
            </div>
          )}

          {main?.new_transfer_fund.length > 0 && (
            <>
              <h6 className="my-3">New Transfer Fund</h6>
              <div className="mt-2 table-scroll">
                <Table striped className="text-body bg-new Roles">
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>Requested Price</th>
                      <th>Requested Quantity</th>
                      <th>Approve Price</th>
                      <th>Approved Quantity</th>
                      <th>Fund Amount </th>
                      <th>Eligible Transfer Quantity </th>
                      <th>Transfer quantity </th>
                      <th>Transfer Amount</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {main?.new_transfer_fund.map((itm, index) => (
                      <>
                        <tr key={index}>
                          <td width={160}>
                            <Select
                              className="text-start"
                              menuPortalTarget={document.body}
                              isDisabled={type !== "create"}
                              name={`transfer_data[${id}].transfer_fund[${index}].item_name`}
                              value={{
                                label: itm?.title?.label,
                                image: itm?.item_image,
                                imgBase64Format: true,
                              }}
                              defaultValue={itm?.title}
                              onChange={(e) => {
                                handleFundRequestDetails(
                                  e.value,
                                  id,
                                  props.setFieldValue,
                                  index,
                                  e.hsncode,
                                );
                                props.setFieldValue(
                                  `request_data[${id}].new_transfer_fund[${index}].current_price`,
                                  e.rate,
                                );
                                props.setFieldValue(
                                  `request_data[${id}].new_transfer_fund[${index}].item_name`,
                                  e,
                                );
                              }}
                              formatOptionLabel={formatOptionLabel}
                            />
                            <ErrorMessage
                              name={`request_data[${id}].new_transfer_fund[${index}].item_name`}
                              component="small"
                              className="text-danger"
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`request_data[${id}].transfer_fund[${index}].requested_rate`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm?.requested_rate ?? ""}
                              disabled={type !== "create"}
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`request_data[${id}].transfer_fund[${index}].requested_qty`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm?.requested_qty ?? ""}
                              disabled={type !== "create"}
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`request_data[${id}].transfer_fund[${index}].current_price`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm?.rate ?? ""}
                              disabled={type !== "create"}
                            />
                            <ErrorMessage
                              name={`request_data[${id}].transfer_fund[${index}].current_price`}
                              component="div"
                              className="field-error"
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`request_data[${id}].new_transfer_fund[${index}].qty`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm?.qty ?? ""}
                              onChange={props.handleChange}
                              disabled={type !== "create"}
                            />
                            <ErrorMessage
                              name={`request_data[${id}].transfer_fund[${index}].qty`}
                              component="div"
                              className="field-error"
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`request_data[${id}].transfer_fund[${index}].fund_amount`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={itm?.fund_amount ?? ""}
                              disabled={type !== "create"}
                            />
                            <ErrorMessage
                              name={`request_data[${id}].new_transfer_fund[${index}].fund_amount`}
                              component="small"
                              className="text-danger"
                            />
                          </td>

                          <td>
                            <Form.Control
                              name={`remaining_quantity`}
                              placeholder="0"
                              type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                              value={
                                edit?.transfer_data
                                  ? edit?.transfer_data?.new_transfer_fund?.[
                                      index
                                    ]?.remaining_quantity
                                  : itm?.qty
                              }
                              disabled={type !== "create"}
                            />
                          </td>

                          <td>
                            {/* FULL TRANSFER ONLY: new-fund transfer qty is locked
                                to the full remaining approved quantity. The user
                                can no longer enter a partial value. The Formik
                                value is force-set (see FullTransferEnforcer below)
                                so the backend receives the full quantity even
                                though the input is read-only. */}
                            <Form.Control
                              name={`transfer_data[${id}].new_transfer_fund[${index}].transfer_quantity`}
                              value={itm?.transfer_quantity ?? ""}
                              type="text"
                              readOnly
                              disabled
                            />

                            {newtransfererror[index] && (
                              <div className="text-danger">
                                Fund limit exceeded
                              </div>
                            )}

                            <ErrorMessage
                              name={`request_data[${id}].new_transfer_fund[${index}].transfer_quantity`}
                              component="div"
                              className="field-error"
                            />
                          </td>

                          <td>
                            {/* FULL TRANSFER ONLY: new-fund transfer amount is
                                locked to the full remaining approved amount and is
                                read-only. */}
                            <Form.Control
                              name={`transfer_data[${id}].new_transfer_fund[${index}].request_transfer_fund`}
                              value={itm?.request_transfer_fund ?? ""}
                              type="text"
                              readOnly
                              disabled
                            />
                          </td>
                          <td>
                            <ItemRemarksCell remarks={itemRemarks} path={`0:new_request_fund:${index}`} stages={["raised", "approved", "transferred"]} canEdit />
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </Table>
              </div>
            </>
          )}

          {main?.new_transfer_fund.length > 0 && (
            <div className="d-flex mt-3 justify-content-end">
              <div className="text-end fw-bold">
                Total New Transfer Fund{" "}
                {formatAmountINR(totalNewTransferFund)}
              </div>
            </div>
          )}
        </div>
      </Form.Group>
      <div className="mt-2 text-end fw-bold ">
        <h5>
          Final Transfer Amount{" "}
          {formatAmountINR(totalTransferFund + totalNewTransferFund)}
        </h5>
      </div>
    </>
  );
};

export default FundTableView;
